module.exports = __webpack_public_path__ + "img/nxt.6f262f67.svg";